import { TimeBlockAbsenceModel } from '../timeblock/time-block.model';
import { AbsencePlannerEventComponent } from '../../../features/absence-planner/planner-event/absence-planner-event.component';

export class AbsencePlannerEventModel<
  T = AbsencePlannerEventComponent,
> extends TimeBlockAbsenceModel<T> {}
